// firebase
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "config/firebase";

// A ---------------------------------------------------------------------- M

export const addFollower = async (userID, tagID) => {
  try {
    const tagDocRef = doc(db, "tagsdata", tagID);
    await updateDoc(tagDocRef, {
      followers: arrayUnion(userID),
    });
    console.log(`[Firestore] Added follower ${userID} to ${tagID}`);
    return true;
  } catch (error) {
    console.error(`[Firestore] Failed to add follower ${userID} to ${tagID}:`, error);
    return false;
  }
};

export const removeFollower = async (userID, tagID) => {
  try {
    const tagDocRef = doc(db, "tagsdata", tagID);
    await updateDoc(tagDocRef, {
      followers: arrayRemove(userID),
    });
    console.log(`[Firestore] Removed follower ${userID} from ${tagID}`);
    return true;
  } catch (error) {
    console.error(`[Firestore] Failed to remove follower ${userID} from ${tagID}:`, error);
    return false;
  }
};
